
import { Table24Filled, Table24Regular, bundleIcon } from "@fluentui/react-icons";

export const TableIcon = bundleIcon(Table24Filled, Table24Regular);